import { ActivatedRoute } from '@angular/router';
import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { ID } from '@datorama/akita';
import { MatDialog } from '@angular/material/dialog';

import { ActionableFormJoin } from '@state/investor';
import { DocumentPreviewDialog } from '@app/shared/components/dialogs/document-preview/document-preview.dialog';
import { NextEvent, SubmitEvent } from '@state/form-wizard';

import { RenderedFormService } from './rendered-form.service';
import { SectionComponent } from './section/section.component';

enum DocumentDownloadType {
  DirectDocumentDownload = 'direct-document-download',
  ModalDocumentPreview = 'modal-document-preview',
  NonModalRtd = 'non-modal-rtd'
}

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'fl-rendered-form',
  styleUrls: ['./rendered-form.component.scss'],
  templateUrl: './rendered-form.component.html'
})
export class RenderedFormComponent implements OnInit {
  @Input() form: any;
  @Input() signatureRequest: any;
  @Input() vehicle?: { entity_id: ID; id: ID };
  @Output() flBack = new EventEmitter<any>();
  @Output() flSubmit = new EventEmitter<any>();
  @Output() flNext = new EventEmitter<any>();

  documentDownloadType: DocumentDownloadType;
  DocumentDownloadType = DocumentDownloadType;

  // directDocumentDownload: boolean;
  // modalDocumentPreview: boolean;
  // nonModalRtd: boolean;

  constructor(
    public dialog: MatDialog,
    public route: ActivatedRoute,
    public renderedFormService: RenderedFormService
  ) {}

  ngOnInit() {
    this.documentDownloadType = this.getDocumentDownloadType();
  }

  documentPreviewLink(form: any): string {
    let signatureRequestForm = this.signatureRequest?.actionable_forms_joins.find(
      (join) => join.form_id === form.id
    );
    let signature_request_form_id: string = signatureRequestForm?.id;
    return `/document/data-request-form/${signature_request_form_id}`;
  }

  // Might be safe to remove after this fix
  documentToPreview(): any {
    let document = this.form.document;

    if (this.signatureRequest) {
      let join = this.signatureRequest.actionable_forms_joins.find(
        // eslint-disable-next-line @typescript-eslint/no-shadow
        (join: ActionableFormJoin) => join.form_id === this.form.id
      );

      if (join) {
        document = join.executed_document || document;
      }
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return document;
  }

  // Might be safe to remove after this fix
  getContentFromForm(formToFindContent: any): any {
    if (this.signatureRequest) {
      let forms = this.signatureRequest.forms.filter((filteredForm) => filteredForm.id === this.form.id);
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
      return forms[0].preview;
    } else {
      let elements = formToFindContent.sections[0].elements.filter(
        (element) => element.element_object_type === 'content'
      );
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
      return elements[0].element_object.parsed_raw_html;
    }
  }

  getDocumentDownloadType(): DocumentDownloadType {
    if (!(this.form?.document || this.form?.rtd)) return;
    let { builder_preview, workflow } = this.route.snapshot.data;
    if (!!(builder_preview || workflow)) return DocumentDownloadType.ModalDocumentPreview;
    if (this.form?.rtd) return DocumentDownloadType.NonModalRtd;
  }

  onSubmit(event?: SubmitEvent): void {
    if (event) {
      this.flSubmit.emit(event);
      return;
    }
    this.flSubmit.emit();
  }

  onBack(event?: SectionComponent): void {
    this.flBack.emit(event);
  }

  onNext(event: NextEvent): void {
    this.flNext.emit(event);
  }

  openDocumentPreview(): void {
    let previewData = this.form.rtd
      ? { content: this.getContentFromForm(this.form) }
      : { document: this.documentToPreview() };

    this.dialog.open(DocumentPreviewDialog, {
      data: previewData,
      width: '800px'
    });
  }
}
